import api from "../api/client";
const options = {
    mediaTypeEndpoint: "api/v1/MediaType",
    data: {},
};
export default {
    GetAllMediaTypes(token, data) {
        options.token = token;
        options.data = data;
        options.endpoint = `${options.mediaTypeEndpoint}/List`;
        return api.list(options);
    },
    AddMediaType(data, token) {
        options.data = data;
        options.token = token;
        options.endpoint = `${options.mediaTypeEndpoint}/`;
        return api.post(options);
    },
    UpdateMediaType(id, data, token) {
        options.data = data;
        options.token = token;
        options.id = id;
        options.endpoint = `${options.mediaTypeEndpoint}`;
        return api.put(options);
    },
    DeleteMediaType(token, id) {
        options.token = token;
        options.endpoint = `${options.mediaTypeEndpoint}/${id}`;
        return api.delete(options);
    },
    GetMediaTypes(entity, data, token) {
        options.token = token;
        options.data = data;
        options.endpoint = `${options.mediaTypeEndpoint}/GetMediaTypes/?entity=${entity}`;
        return api.get(options);
    },
};